<script lang="ts" setup>
import type { IOtherReviewsPopupData } from './models';
import { MMPopupDefault, MMText, MMIcon } from '@mm-frontend/mm-web-ui-kit';
import { Plural } from '@/shared/helpers';

const props = defineProps<{
  onShowData: IOtherReviewsPopupData;
}>();

const reviewsLabel = computed(() => Plural.with(props.onShowData.reviews, 'оценка|оценки|оценок'));
</script>

<template>
  <MMPopupDefault is-closable class="other-reviews-popup" @close="$emit('close')">
    <template #header>
      <MMText font="Title S/Semibold" class="other-reviews-popup__header">
        Общий рейтинг товара
      </MMText>
    </template>

    <template #default>
      <div class="other-reviews-popup__body">
        <div class="other-reviews-popup__body__rating">
          <MMIcon name="star-filled" :width="24" :height="24" />
          <MMText font="Headline M/Semibold">{{ onShowData.rating.toFixed(1) }}</MMText>
          <MMText font="Body L/Regular Long" style="margin-left: 8px">{{ reviewsLabel }}</MMText>
        </div>

        <MMText font="Body L/Regular Long" class="other-reviews-popup__body__info">
          <div>Другие площадки</div>
          <div class="other-reviews-popup__body__info__dots" />
          <div>{{ onShowData.rating.toFixed(1) }} · {{ reviewsLabel }}</div>
        </MMText>

        <MMText font="Body L/Regular Long" class="other-reviews-popup__body__info">
          <span>Магнит Маркет</span>
          <div class="other-reviews-popup__body__info__dots" />
          <span>Нет отзывов</span>
        </MMText>

        <MMText font="Title S/Semibold" style="margin-top: 24px">
          Как формируется рейтинг товара
        </MMText>
        <MMText font="Body L/Regular Long">
          Для расчёта рейтинга этого товара мы получили проверенные и актуальные отзывы на
          идентичный товар от того же продавца на других маркетплейсах, чтобы вы могли принять
          информированное решение о покупке
        </MMText>
      </div>
    </template>
  </MMPopupDefault>
</template>

<style lang="stylus" scoped>
.other-reviews-popup
  +Media(Laptop, Desktop, DesktopMax)
    width 540px

  &__header
    padding-bottom 24px
    text-align center

  &__body
    display flex
    flex-direction column
    gap 8px

    &__rating
      background var(--surface-secondary-rest)
      border-radius 16px
      padding 12px 16px
      display flex
      align-items center
      gap 8px

    &__info
      display flex
      gap 6px
      &__dots
        flex-grow 1
        margin-bottom 5px
        background-image radial-gradient(circle, var(--text-tertiary) 1px, transparent 1px)
        background-size 6px 2px
        background-repeat repeat-x
        background-position bottom
</style>
